import { useTranslation } from '@/hooks/useTranslation';
import { ModalType, useModalContext } from '@/context/ModalContext';
import { useCallback } from 'react';
import { useConfigContext } from '@/context/ConfigContext';
import {
  ModalActions,
  ModalContent,
  ModalContentText,
  ModalHeader,
  ModalIcon,
  ModalSubmitButton,
  ModalTitle,
} from '@/components/Modal/Elements';
import { LockedErrorIcon } from '@/icons';
import BaseModal from '@/components/Modal/BaseModal/BaseModal';
import CloseButton from '@/components/Modal/Elements/Close/CloseButton';

const ServerIsUnavailableErrorModal: React.FC = () => {
  const { t } = useTranslation();
  const { close } = useModalContext();
  const { configState } = useConfigContext();

  const supportEmail = configState.value?.support_email;

  const handleClose = useCallback(() => {
    close(ModalType.SERVER_UNAVAILABLE);
  }, []);

  return (
    <BaseModal onClose={handleClose}>
      <ModalHeader>
        <CloseButton onClick={handleClose} />
      </ModalHeader>
      <ModalIcon>
        <LockedErrorIcon />
      </ModalIcon>
      <ModalContent>
        <ModalTitle>{t('modal.error.server_unavailable.title')}</ModalTitle>
        <ModalContentText>{t('modal.error.server_unavailable.sub_title')}</ModalContentText>
      </ModalContent>
      <ModalActions>
        <ModalSubmitButton href={`mailto:${supportEmail}`} onClick={handleClose} text={t('button.contact_support')} />
      </ModalActions>
    </BaseModal>
  );
};

export default ServerIsUnavailableErrorModal;
